import { Button, styled } from '@ltvco/refresh-lib/theme';

import { ChatPageContainerStack } from 'components/ChatBV/components/ChatPage/ChatComponents/components';

export const PageContainer = styled(ChatPageContainerStack)({
  width: '100%',
  height: '100%',
  overflowY: 'hidden',
});

export const PaginationButton = styled(Button)({
  minWidth: 36,
});

export const UpdatesButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  color: theme.palette.primary.main,
}));

export const ViewButton = styled(Button)({
  textTransform: 'none',
  fontWeight: 600,
});
